import { render, staticRenderFns } from "./app-sidebar.vue?vue&type=template&id=b42c3460&scoped=true&"
import script from "./app-sidebar.vue?vue&type=script&lang=js&"
export * from "./app-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./app-sidebar.vue?vue&type=style&index=0&id=b42c3460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c3460",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b42c3460')) {
      api.createRecord('b42c3460', component.options)
    } else {
      api.reload('b42c3460', component.options)
    }
    module.hot.accept("./app-sidebar.vue?vue&type=template&id=b42c3460&scoped=true&", function () {
      api.rerender('b42c3460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/app-sidebar.vue"
export default component.exports